import React, { Component } from 'react';
import {withRouter} from "react-router-dom";

class ScrollToTopOnload extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
          setTimeout(function(){
            window.scrollTo(0, 0);
          }, 750); // In-Animation goes over 750ms
      }
    }
  
    render() {
      return this.props.children;
    }
  }
  
export default withRouter(ScrollToTopOnload);